import { useCallback, useEffect, useMemo, useReducer } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROOT } from '../../constants/routeTemplates';
import CustomRouterContext from './RouterContext';
import { reducer, urlWasChanged } from './reducer';

// TODO: need refactoring to more stack-like structure (solution from pm-casino)
const CustomRouterContextProvider = ({ children }) => {
  const location = useLocation();
  const history = useHistory();

  const [state, dispatch] = useReducer(reducer, [ROOT]);

  const lastUrl = useMemo(() => {
    return state?.length > 2 ? state[state?.length - 2] : ROOT;
  }, [state]);

  useEffect(() => {
    dispatch(urlWasChanged(location.pathname));
  }, [location]);

  const goPrevUrl = useCallback(() => {
    history.push(lastUrl);
  }, [lastUrl, history]);

  const contextValue = useMemo(
    () => ({
      goBack: goPrevUrl,
      lastUrl,
    }),
    [lastUrl, goPrevUrl]
  );

  return (
    <CustomRouterContext.Provider value={contextValue}>
      {children}
    </CustomRouterContext.Provider>
  );
};
export default CustomRouterContextProvider;
